import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetPunchoutApiParameter } from "@TKCCP/Services/tkccpPunchoutService";
import PunchoutSecretPageState from "@TKCCP/Store/Pages/PunchoutSecret/PunchoutSecretState";
import { Draft } from "immer";

const initialState: PunchoutSecretPageState = {
    getPunchoutParameter: { page: 1, pageSize: 8, query: "", expand: ["top3products"], sort: "ModifiedOn DESC" },
    // getPunchoutParameter: {
    //     // sort: "Identity desc",
    //     query: "",
    // },
    // isFilterOpen: false,
};

const reducer = {
    "Pages/PunchoutSecret/UpdateLoadParameter": (
        draft: Draft<PunchoutSecretPageState>,
        action: { parameter: GetPunchoutApiParameter },
    ) => {
        draft.getPunchoutParameter = { ...draft.getPunchoutParameter, ...action.parameter };

        for (const key in draft.getPunchoutParameter) {
            const value = (<any>draft.getPunchoutParameter)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.getPunchoutParameter)[key];
            }
        }

        for (const key in action.parameter) {
            // go back to page 1 if any other parameters changed
            if (draft.getPunchoutParameter.page && draft.getPunchoutParameter.page > 1 && key !== "page") {
                draft.getPunchoutParameter.page = 1;
            }
        }
    },
};

const punchoutSecretPageReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).pagePunchoutSecret = punchoutSecretPageReducer;
